// extracted by mini-css-extract-plugin
export var searchHeader = "_23-0";
export var searchHeaderDark = "_23-1";